module.exports = __webpack_public_path__ + "static/media/st-sebas.59cc7f3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/st-sebas.jpg
// module id = 636
// module chunks = 0